import { CatIconArrowTriangularRight } from '@blocks-react/components/Icons/ArrowTriangularRight';
import { StoreHoursInfoDetailsProps } from './types';
import styles from '../store-hours-info.module.scss';
import cx from 'classnames';

export const StoreHoursInfoDetails = ({
  storeHoursInfoDetails: { label, currentDay, value }
}: StoreHoursInfoDetailsProps) => {
  return (
    <div className="d-flex flex-row text-sm mb-1" key={label}>
      <div
        className={cx('d-flex flex-row flex-grow-1 text-start mb-0', {
          'align-items-center': !!currentDay
        })}
      >
        {currentDay ? (
          <CatIconArrowTriangularRight
            data-testid="cat-triangle-icon"
            slot="before"
          />
        ) : null}
        <p
          className={cx('m-0 exclude-global', styles['store-hours-info-text'], {
            'cat-u-theme-typography-label': !!currentDay,
            'cat-u-theme-typography-body-sm': !currentDay
          })}
        >
          {label}
        </p>
      </div>
      <p
        className={cx(
          'flex-grow-1 text-end mb-0 exclude-global',
          styles['store-hours-info-text'],
          {
            'cat-u-theme-typography-label': !!currentDay,
            'cat-u-theme-typography-body-sm': !currentDay
          }
        )}
      >
        {value}
      </p>
    </div>
  );
};
